

export const getCourseData = async () => { 
  const response = await fetch('https://api-j06q.onrender.com/api/course/available-courses');
  const data = await response.json();
  return data;

}